import { render } from "./TermsAndConditionsModal.vue?vue&type=template&id=011b1cd7"
import script from "./TermsAndConditionsModal.vue?vue&type=script&lang=js"
export * from "./TermsAndConditionsModal.vue?vue&type=script&lang=js"

import "./TermsAndConditionsModal.vue?vue&type=style&index=0&id=011b1cd7&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__